webpackJsonp([265343770855089],{

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/crate_and_barrel.4a7c0102.jpg";

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ikea.44b447c6.jpg";

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rome.6401429c.jpg";

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/crate_and_barrel@2x.787ec87d.jpg";

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ikea@2x.ea1be4ea.jpg";

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rome@2x.c81cacc8.jpg";

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(57);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Polaroid = __webpack_require__(58);
	
	var _Polaroid2 = _interopRequireDefault(_Polaroid);
	
	var _Header = __webpack_require__(22);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(21);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _rome = __webpack_require__(493);
	
	var _rome2 = _interopRequireDefault(_rome);
	
	var _rome2x = __webpack_require__(496);
	
	var _rome2x2 = _interopRequireDefault(_rome2x);
	
	var _crate_and_barrel = __webpack_require__(491);
	
	var _crate_and_barrel2 = _interopRequireDefault(_crate_and_barrel);
	
	var _crate_and_barrel2x = __webpack_require__(494);
	
	var _crate_and_barrel2x2 = _interopRequireDefault(_crate_and_barrel2x);
	
	var _ikea = __webpack_require__(492);
	
	var _ikea2 = _interopRequireDefault(_ikea);
	
	var _ikea2x = __webpack_require__(495);
	
	var _ikea2x2 = _interopRequireDefault(_ikea2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GIVE_A_GIFT = 'Give a Gift';
	var DONATE = 'Donate via PayPal';
	var IKEA_URL = 'https://info.ikea-usa.com/giftregistry/en-us/registry/a08a4c5a-8582-4656-ac1d-ca1d6641aefb';
	var PAYPAL_URL = 'https://paypal.me/lincolncroughwell';
	var CRATE_BARREL_URL = 'https://www.crateandbarrel.com/gift-registry/andrew-lincoln-and-sarah-croughwell/r5869521';
	var polaroid_crate_and_barrel = {
	  image: {
	    src: _crate_and_barrel2.default,
	    src2x: _crate_and_barrel2x2.default,
	    alt: 'The Colliseum in Rome'
	  },
	  heading: 'Crate & Barrel',
	  body: 'Browse furniture, home decor, cookware, dinnerware, wedding registry and more.',
	  alignment: 'right',
	  button: {
	    label: GIVE_A_GIFT,
	    href: CRATE_BARREL_URL
	  }
	};
	var polaroid_ikea = {
	  image: {
	    src: _ikea2.default,
	    src2x: _ikea2x2.default,
	    alt: ''
	  },
	  heading: 'IKEA',
	  body: 'Here are a few favorite things from IKEA. Thanks for being part of our special event!',
	  alignment: 'right',
	  button: {
	    label: GIVE_A_GIFT,
	    href: IKEA_URL
	  }
	};
	var polaroid_rome = {
	  theme: 'light',
	  image: {
	    src: _rome2.default,
	    src2x: _rome2x2.default,
	    alt: ''
	  },
	  heading: 'Donate to Our Honeymoon',
	  body: 'Chip in to help us pay for our trip to Italy we will be taking in the Spring.',
	  links: [{ label: 'Book at the Inn and Conference Center', href: '/' }, { label: 'Book at the Fairfield', href: '/' }],
	  alignment: 'right',
	  button: {
	    label: DONATE,
	    href: PAYPAL_URL
	  }
	};
	var RegistryPage = function RegistryPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'registry-page' },
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(_Hero2.default, {
	      heading: 'Registry',
	      subheading: 'The best gift, of course, is your attendance, but if you would like to get us a gift we are registered at the places below.',
	      color: 'green'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'registry-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'registry' },
	        _react2.default.createElement(_Polaroid2.default, polaroid_crate_and_barrel),
	        _react2.default.createElement(_Polaroid2.default, polaroid_ikea),
	        _react2.default.createElement(_Polaroid2.default, polaroid_rome)
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = RegistryPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-registry-js-11d15dac25ec395eabfa.js